import { createDraftApiClient, type DraftApiClient } from "./api/draft";
import { installFormFieldAdapter, type FormFieldAdapter } from "./adapters/mds-form-field";
import { buildDraftPayload, type BuildDraftPayloadOptions, type DraftPayload } from "./form/payload";

export interface Phase3BridgeOptions {
  apiCandidates: string[];
  unavailableMessage: (lastError: string) => string;
}

export interface Phase3Contract {
  installed: true;
  adapter: FormFieldAdapter;
  nativeElements: HTMLFormControlsCollection;
  apiClient: DraftApiClient;
  readFieldValue(name: string): string;
  writeFieldValue(name: string, value: string | number | boolean | null | undefined): void;
  serializeForm(): Record<string, string | string[]>;
  buildPayload(options: Omit<BuildDraftPayloadOptions, "fields">): DraftPayload;
}

export function installPhase3Bridge(form: HTMLFormElement, options: Phase3BridgeOptions): Phase3Contract {
  const { adapter, nativeElements } = installFormFieldAdapter(form);
  const apiClient = createDraftApiClient({
    candidates: options.apiCandidates,
    unavailableMessage: options.unavailableMessage
  });

  return {
    installed: true,
    adapter,
    nativeElements,
    apiClient,
    readFieldValue: adapter.readFieldValue,
    writeFieldValue: adapter.writeFieldValue,
    serializeForm: adapter.serializeForm,
    buildPayload: payloadOptions => buildDraftPayload({ fields: adapter, ...payloadOptions })
  };
}

export { buildDraftPayload, createDraftApiClient };
